import React from 'react';

function IconPerformance2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        fill="#00B7B2"
        d="M6 1.5a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm0 3.75c.065 0 .13.01.192.028l1.543-1.543a.375.375 0 01.53.53L6.722 5.808A.749.749 0 116 5.25zm0 4.725a3.967 3.967 0 01-3.18-1.601.973.973 0 001.097.14 4.472 4.472 0 014.166 0 .973.973 0 001.097-.14A3.967 3.967 0 016 9.976z"
      ></path>
    </svg>
  );
}

export const SvgIconPerformance2 = React.memo(IconPerformance2);
